<template>
    <inertia-link :href="href" :class="classes">
        <slot></slot>
    </inertia-link>
</template>

<script>
export default {
    props: [
        'href',
        'active'
    ],

    computed: {
        classes () {
            return this.active
                ? 'bg-glm-red text-white block px-3 py-2 rounded-md text-base font-medium'
                : 'transition-all text-glm-black hover:bg-grey-600 hover:text-white block px-3 py-2 rounded-md text-base font-medium'
        },
    },
}
</script>
